import React, { useContext, useEffect, useState } from 'react';
import { AlumnosContext } from './../../../context/alumnos/AlumnosContext';
import { UserContext } from './../../../context/users/UserContext';
import { FormInputStyled } from './../../../assets/styled';
import { arrayMeses } from '../../../utilities/utils';

export default function Botonera({ asistencia, pagos, id }) {
	const [switcher, setSwitcher] = useState(false);
	const [pagoLocal, setPagoLocal] = useState('');
	const [mesLocal, setMesLocal] = useState('ENERO');
	const [añoLocal, setAñoLocal] = useState(new Date().getFullYear());

	const alumnoCtx = useContext(AlumnosContext);
	const userCtx = useContext(UserContext);

	const { handleFaltas, handlePagos } = alumnoCtx;

	const handleClick = () => {
		if (asistencia) {
			setSwitcher(true);
			handleFaltas(id);
		}
		
		if (pagos) {
			handlePagos(id, pagoLocal, mesLocal, añoLocal);
			setPagoLocal(''); // Limpiar el input después de pagar
		}
	};

	useEffect(() => {
		switcher &&
			setTimeout(() => {
				setSwitcher(false);
			}, 21600000);
	}, [switcher]);

	return (
		<>
			{asistencia && (
				<button
					onClick={handleClick}
					disabled={switcher}
					className={` btn btn-warning mr-2`}
				>
					Presente
				</button>
			)}
			{pagos && (
				<>
					<select
						className='form-select mr-2'
						name='año'
						style={{ width: '100px' }}
						onChange={(e) => setAñoLocal(parseInt(e.target.value))}
						value={añoLocal}
					>
						{Array.from({ length: 5 }, (_, i) => {
							const año = new Date().getFullYear() - 2 + i;
							return (
								<option key={año} value={año}>
									{año}
								</option>
							);
						})}
					</select>
					<select
						className='form-select mr-2 w-25'
						name='mes'
						onChange={(e) => setMesLocal(e.target.value)}
						value={mesLocal}
					>
						{arrayMeses.map((mes, index) => {
							return (
								<option key={index} value={mes}>
									{mes}
								</option>
							);
						})}
					</select>
					<div style={{ display: 'inline-block' }} className='w-20'>
						<FormInputStyled
							type='number'
							placeholder='Pago'
							value={pagoLocal}
							onChange={(e) => setPagoLocal(e.target.value)}
							style={{ padding: '10px 6px', fontSize: '14px', border: '1px solid #ced4da', borderRadius: '5px' }}
						/>
					</div>
					<button onClick={handleClick} className=' btn btn-warning'>
						Pagar
					</button>
				</>
			)}
		</>
	);
}
